import { ReactNode, useMemo, useState } from 'react';
import RegulationListDataContext from '@raas/shared/src/features/regulation/contexts/RegulationListDataContext';

import type { RegulationListDataContextContract } from '@raas/shared/src/features/regulation/contexts/RegulationListDataContext';
import type { RegulationContract } from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { PaginationParamsContract } from '@raas/shared/src/features/pagination';

type RegulationListContextProviderProps = {
  children: ReactNode;
};

export function RegulationListContextProvider({ children }: RegulationListContextProviderProps) {
  const [regulations, setRegulations] = useState<RegulationContract[]>([]);
  const [isListLoading, setIsListLoading] = useState<boolean>(false);
  const [nextCursor, setNextCursor] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [paginationParams, setPaginationParams] = useState<PaginationParamsContract>({});

  const dataValue: RegulationListDataContextContract = useMemo(
    () => ({
      regulations,
      isListLoading,
      nextCursor,
      hasMore,
      paginationParams,
      setRegulations,
      setIsListLoading,
      setNextCursor,
      setHasMore,
      setPaginationParams,
    }),
    [regulations, isListLoading, nextCursor, hasMore, paginationParams]
  );
  return (
    <RegulationListDataContext.Provider value={dataValue}>
      {children}
    </RegulationListDataContext.Provider>
  );
}
